import { Navigate, useLocation } from 'react-router-dom';

type PreserveQueryRedirectProps = {
  /** Target pathname, without a query string of its own. */
  to: string;
};

/**
 * Redirects while carrying the query string across.
 *
 * Enrollment entry points identify the offer purely through `?offer_code` / `?plan_code` (and
 * sometimes `?token`, `?email_address`, `?participantToken`), so a bare `<Navigate>` would drop
 * the member into a flow with nothing to enrol into.
 */
function PreserveQueryRedirect({ to }: PreserveQueryRedirectProps) {
  const { search } = useLocation();
  return <Navigate to={`${to}${search}`} replace />;
}

export default PreserveQueryRedirect;
